module.exports = ".cursor-not-allowed {\n    cursor: not-allowed;\n}\n"